import React, { useCallback, useEffect, useState } from 'react'

import { useSelector } from 'react-redux'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import ContractsModal from '../../components/ContractsModal'
import Dialog from '../../components/Dialog'
import Loading from '../../components/Loading'
import RowsTableExtratos from '../../components/RowsTableExtratos'
import api, { operation } from '../../services/axios'
import { StoreState } from '../../store'
import { cnpjCpfMask } from '../../utils/masks'
import { ContratoProtocol } from '../Extratos/interfaces'
import {
    Container,
    LinkData,
    LinkContracts,
    Header,
    ContractsTable,
    Recurrence,
    Back,
} from './styles'
import { frequenciaCobranca } from '../../utils/frequenciaCobranca'
import { get } from 'lodash'
import swal from 'sweetalert'
import { useBancos } from '../../hooks/bancos'
import { useDispatch } from 'react-redux'
import { selectedMenu } from '../../store/modules/menu/actions'
import { TbArrowBackUp } from 'react-icons/tb'
import { BillingProtocol } from './interface'
import dayjs from '../../libs/dayjs'

const LinkIndividual: React.FC = () => {
    const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)
    const { id } = useParams()
    const [searchParams] = useSearchParams()
    const { bancos } = useBancos()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [billingLink, setBillingLink] = useState<BillingProtocol>(
        {} as BillingProtocol
    )
    const [contracts, setContracts] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [contractSelected, setContractSelected] = useState(
        {} as ContratoProtocol
    )
    // const [contractsExport, setContractsExport] = useState<
    //     GarantiasContratoCsv[]
    // >([])
    const [isModalOpen, setIsModalOpen] = useState(false)
    // precisa tratar o acesso do usuario e se esse id é valido

    const getBilling = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                setIsLoading(true)
                const { data } = await api.get(
                    `/cobranca/individual/${cnpj_cpf}/${id}?criadorCobranca=${searchParams.get(
                        'criadorCobranca'
                    )}`
                )
                setBillingLink(data.cobranca)
                setContracts(data.contratos)
                // const res = await api.get(`/recorrencia/garantias/${cnpj_cpf}/${id}`)
                // setContractsExport(res.data)
                setIsLoading(false)
            } catch (error: any) {
                setIsLoading(false)
                const status = get(error, 'response.status', '')
                if (status === 403 || status === 400) {
                    swal({
                        title: 'Erro ao buscar cobrança',
                        text: `Você não tem acesso a esta cobrança ou ela não existe mais.`,
                        icon: 'error',
                    })
                    navigate('/cobrancas')
                }

                if (status === 401) {
                    if (operation.retry(error)) return
                }
            }
        })
    }, [cnpj_cpf, id, navigate, searchParams])

    useEffect(() => {
        getBilling()
    }, [getBilling])

    // const dataCsv = contractsExport?.map(garantia => {
    //     const banco = bancos[garantia.DP_compe]
    //     const credenciadora = credenciadoras[garantia.contrato.credenciadora as keyof typeof credenciadoras]
    //     const bandeira = arranjosPrincipais[garantia.DefUR_listaCodigoArranjoPagamento as keyof typeof arranjosPrincipais]
    //     return {
    //         RefExtContrato: garantia.contrato.referenciaExterna,
    //         protocolo: garantia.contrato?.contratoRetorno?.protocolo,
    //         tipoContrato: garantia.contrato.tipoContrato,
    //         dataAssinatura: garantia.contrato?.dataAssinatura,
    //         crendeciadora: credenciadora,
    //         cnpjParticipante: garantia.contrato?.cnpjParticipante,
    //         tipoServico: garantia.contrato?.statusContrato,
    //         tipoEfeito: garantia.contrato?.tipoEfeito,
    //         modalidadeOp: garantia.contrato?.modalidadeOperacao,
    //         canal: garantia.contrato?.canal,
    //         cnpjPagador: garantia.contrato?.cnpjPagador,
    //         pagador: garantia.contrato?.nomePagador,
    //         cnpjRecebedor: garantia.contrato?.cnpjRecebedor,
    //         recebedor: garantia.contrato?.nomeRecebedor,
    //         banco: banco,
    //         compe: garantia.DP_compe,
    //         ispb: garantia.DP_ispb,
    //         agencia: garantia.DP_agencia,
    //         conta: garantia.DP_numeroConta,
    //         tipoConta: garantia.DP_tipoConta,
    //         DataVencimentoUR: garantia.DefUR_dataFim,
    //         bandeira: bandeira,
    //         valorUR: garantia.valorAOnerar,
    //         valorTotalContrato: garantia.contrato?.saldoDevedor,
    //         situacao: !garantia.contrato?.visibilidade ? 'Pendente de confirmação da registradora' : garantia.contrato?.situacao,
    //         obs: garantia.contrato?.observacao,
    //     }
    // })

    // const exportFile = useCallback(() => {
    //     const dataXlsx = contractsExport?.map(garantia => {
    //         const banco = bancos[garantia.DP_compe]
    //         const credenciadora = credenciadoras[garantia.contrato.credenciadora as keyof typeof credenciadoras]
    //         const bandeira = arranjosPrincipais[garantia.DefUR_listaCodigoArranjoPagamento as keyof typeof arranjosPrincipais]
    //         return {
    //             "Referência externa": garantia.contrato.referenciaExterna,
    //             "Protocolo": garantia.contrato.contratoRetorno?.protocolo,
    //             "Tipo do contrato": garantia.contrato?.tipoContrato,
    //             "Data de assinatura": garantia.contrato?.dataAssinatura,
    //             "Crendeciadora": credenciadora,
    //             "Cnpj do participante": garantia.contrato?.cnpjParticipante,
    //             "Tipo de servico": garantia.contrato?.statusContrato,
    //             "Tipo do efeito": garantia.contrato?.tipoEfeito,
    //             "Modalidade de operação": garantia.contrato?.modalidadeOperacao,
    //             "Canal": garantia.contrato?.canal,
    //             "Cnpj do pagador": garantia.contrato?.cnpjPagador,
    //             "Pagador": garantia.contrato?.nomePagador,
    //             "Cnpj do recebedor": garantia.contrato?.cnpjRecebedor,
    //             "Recebedor": garantia.contrato?.nomeRecebedor,
    //             "Banco": banco,
    //             "Compe": garantia.DP_compe,
    //             "Ispb": garantia.DP_ispb,
    //             "Agência": garantia.DP_agencia,
    //             "Conta": garantia.DP_numeroConta,
    //             "Tipo de conta": garantia.DP_tipoConta,
    //             "Data de vencimento da UR": garantia.DefUR_dataFim,
    //             "Bandeira": bandeira,
    //             "Valor da UR": garantia.valorAOnerar,
    //             "Valor total do contrato": garantia.contrato?.saldoDevedor,
    //             "Situação do contrato": !garantia.contrato?.visibilidade ? 'Pendente de confirmação da registradora' : garantia.contrato?.situacao,
    //             "Observação": garantia.contrato?.observacao,
    //         }
    //     })
    //     const ws = utils.json_to_sheet(dataXlsx);
    //     const wb = utils.book_new();
    //     utils.book_append_sheet(wb, ws, "Data");
    //     writeFileXLSX(wb, "Recorrencia.xlsx");
    // }, [contractsExport, bancos]);

    // const valorTotalContracts = contracts.reduce(
    //     (sum: number, contrato: ContratoProtocol) =>
    //         sum + Number(contrato.saldoDevedor),
    //     0
    // )

    function handleSelectContract(contract: ContratoProtocol) {
        setContractSelected(contract)
        setIsModalOpen(true)
    }

    function renderContractRows() {
        return contracts.map((contract: ContratoProtocol) => {
            return (
                <RowsTableExtratos
                    key={contract.id}
                    contract={contract}
                    handleSelectContract={handleSelectContract}
                />
            )
        })
    }

    function billingLinkInfo() {
        if (
            billingLink.tipoCobranca === 0 &&
            Number(billingLink.quantParcelas) === 1
        ) {
            return (
                <>
                    <p>
                        <strong className="canal">Forma de pagamento: </strong>{' '}
                        À vista
                    </p>
                    <p>
                        <strong className="op">1ª data liquidação: </strong>
                        {dayjs(billingLink.dataLiquidacao).format('DD/MM/YYYY')}
                    </p>
                </>
            )
        }

        if (
            billingLink.tipoCobranca === 0 &&
            Number(billingLink.quantParcelas) > 1
        ) {
            return (
                <>
                    <p>
                        <strong className="canal">Forma de pagamento: </strong>{' '}
                        Parcelado
                    </p>
                    <p>
                        <strong className="canal">Número de parcelas: </strong>{' '}
                        {billingLink.quantParcelas} parcelas
                    </p>
                    <p>
                        <strong className="op">1ª data liquidação: </strong>
                        {dayjs(billingLink.dataLiquidacao).format('DD/MM/YYYY')}
                    </p>
                </>
            )
        }

        if (billingLink.tipoCobranca === 1) {
            return (
                <>
                    <p>
                        <strong className="canal">Forma de pagamento: </strong>{' '}
                        Recorrente
                    </p>
                    <p>
                        <strong className="canal">
                            Frequência da cobrança:{' '}
                        </strong>{' '}
                        {
                            frequenciaCobranca[
                                Number(
                                    billingLink.frequenciaCobranca
                                ) as keyof typeof frequenciaCobranca
                            ]
                        }
                    </p>
                    <p>
                        <strong className="op">1ª data liquidação: </strong>
                        {dayjs(billingLink.dataLiquidacao).format('DD/MM/YYYY')}
                    </p>
                </>
            )
        }

        if (billingLink.tipoCobranca === 2) {
            return (
                <>
                    <p>
                        <strong className="canal">Forma de pagamento: </strong>{' '}
                        Porcetagem da agenda diária
                    </p>
                    <p>
                        <strong className="canal">Porcentagem: </strong>{' '}
                        {billingLink.porcentagemSobreAgenda}%
                    </p>
                    <p>
                        <strong className="op">Receba: </strong>
                        <span className="text-sm">partir de</span>{' '}
                        {dayjs(billingLink.dataLiquidacao).format('DD/MM/YYYY')}{' '}
                        <span className="text-sm">até</span>{' '}
                        {dayjs(billingLink.dataLiquidacaoFinal).format(
                            'DD/MM/YYYY'
                        )}
                        .
                    </p>
                </>
            )
        }
    }
    return (
        <Container>
            <Back
                onClick={() =>
                    navigate(
                        `/cobrancas?${
                            searchParams.get('criadorCobranca') === 'true'
                                ? 'm=true'
                                : 'p=true'
                        }`
                    )
                }
            >
                <TbArrowBackUp size={33} color="#272D2D" />
            </Back>
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    {searchParams.get('criadorCobranca') === 'false' &&
                        billingLink.tipoCobranca === 1 && (
                            <Recurrence>
                                {/* <Link to={`/recorrencia/${billingLink?.recorrencia?.id}`} onClick={() => dispatch(selectedMenu({ mainMenu: 'Recorrência', subMenu: '', currentLink: '/recorrencia' }))}><Button variant='contained'>Página da recorrência</Button></Link> */}
                                <p>
                                    Esta é uma cobrança recorrente,{' '}
                                    <Link
                                        to={`/recorrencia/${billingLink?.identificadorRecorrencia}`}
                                        onClick={() =>
                                            dispatch(
                                                selectedMenu({
                                                    mainMenu: 'Recorrência',
                                                    subMenu: '',
                                                    currentLink: '/recorrencia',
                                                })
                                            )
                                        }
                                    >
                                        clique aqui
                                    </Link>{' '}
                                    para acessar a página da recorrência.
                                </p>
                            </Recurrence>
                        )}
                    <LinkData>
                        <div className="input-group">
                            <h3>Valor pago</h3>
                            <div className="wrapper">
                                <p>
                                    {Number(billingLink.valor).toLocaleString(
                                        'pt-br',
                                        { style: 'currency', currency: 'BRL' }
                                    )}
                                </p>
                            </div>
                        </div>

                        <div className="input-group">
                            <div className="wrapper info">
                                <p>
                                    <strong className="situation">
                                        Situação da cobrança:{' '}
                                    </strong>
                                    {billingLink.situacao}
                                </p>
                                {billingLinkInfo()}

                                <p>
                                    <strong className="op">
                                        Número da operação:{' '}
                                    </strong>
                                    {billingLink.numeroOperacao}
                                </p>
                                {searchParams.get('criadorCobranca') ===
                                    'true' && (
                                    <>
                                        <p>
                                            <strong className="canal">
                                                Nome da cobrança:{' '}
                                            </strong>
                                            {billingLink.nomeCobranca}
                                        </p>
                                        {/* <button className="flex items-center gap-x-2 text-blue-400">
                                            <strong className="canal">
                                                Copiar link
                                            </strong>{' '}
                                            <FiCopy color="#333" size={18} />
                                        </button> */}
                                    </>
                                )}
                                <p>
                                    <strong className="canal">
                                        Canal de origem:{' '}
                                    </strong>
                                    {billingLink.canal}
                                </p>
                                {/* <p><strong className='canal'>Duração: </strong>{recurrence.duracao} meses</p> */}
                            </div>
                        </div>

                        <div className="input-group">
                            <h3>Dados do recebedor</h3>
                            <div className="receiver">
                                <div className="wrapper">
                                    <strong>Para: </strong>
                                    <p>{billingLink.nomeTitular}</p>
                                </div>
                                <div className="wrapper">
                                    <p>
                                        <strong>Cpf/Cnpj: </strong>{' '}
                                        {cnpjCpfMask(
                                            billingLink.numeroDocumentoTitular ||
                                                ''
                                        )}
                                    </p>
                                </div>
                            </div>
                            <h4>Domicílio bancário: </h4>
                            <div className="flex">
                                <div className="wrapper">
                                    <p>Banco: {bancos[billingLink.compe]}</p>
                                </div>
                                <div className="wrapper">
                                    <p>Agência: {billingLink.agencia}</p>
                                </div>
                                <div className="wrapper">
                                    <p>
                                        Número da conta:{' '}
                                        {billingLink.numeroConta}
                                    </p>
                                </div>
                            </div>
                            <div className="wrapper">
                                <p>Tipo de conta: {billingLink.tipoConta}</p>
                            </div>
                        </div>

                        {/* <h4>Contato: </h4>
                <div className="flex">
                    <div className="wrapper">
                        <p><span>Email: </span>{contract.emailRecebedor}</p>
                    </div>
                    <div className="wrapper">
                        <p><span>Telefone: </span>{foneMask(contract.foneRecebedor)}</p>
                    </div>
                </div> */}

                        <div className="input-group">
                            <h3>Dados do pagador</h3>
                            <div className="wrapper">
                                <strong>De: </strong>
                                <p>{billingLink.nomePagador}</p>
                            </div>
                            <div className="wrapper">
                                <p>
                                    <strong>Cpf/Cnpj: </strong>
                                    {cnpjCpfMask(billingLink.cnpjPagador || '')}
                                </p>
                            </div>
                        </div>

                        <div className="input-group">
                            <div className="wrapper details">
                                <p>
                                    Data e hora da criação:{' '}
                                    {dayjs(billingLink.dataCriacao).format(
                                        'DD/MM/YYYY - HH:mm:ss'
                                    )}
                                </p>
                                <p>
                                    Observação:{' '}
                                    {billingLink.observacao || 'n/a'}
                                </p>
                            </div>
                        </div>
                    </LinkData>
                    {searchParams.get('criadorCobranca') === 'false' && (
                        <>
                            <LinkContracts>
                                <Header>
                                    <div className="title">
                                        <h2>Contrato da cobrança</h2>
                                    </div>
                                    <div className="exports">
                                        {/* <CSVLink data={dataCsv} filename='Recorrencia.csv' headers={headers}>
                                    <button><FiDownload size={18} /> Exportar CSV</button>
                                </CSVLink>
                                <button onClick={exportFile}><FiDownload size={18} /> Exportar XLSX</button> */}
                                    </div>
                                </Header>

                                <ContractsTable>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Data</th>
                                            <th>
                                                CNPJ/CPF <br />
                                                (Quem vai receber)
                                            </th>
                                            <th className="recedor">
                                                Recebedor
                                            </th>
                                            <th className="adq">Adq</th>
                                            <th className="categoria"></th>
                                            <th>Valor</th>
                                            <th className="tipo">Tipo</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>

                                    <tbody>{renderContractRows()}</tbody>

                                    {/* <tfoot>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>Total</td>
                                            <td>{valorTotalContracts?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                            <td></td>
                                        </tr>
                                    </tfoot> */}
                                </ContractsTable>
                            </LinkContracts>
                        </>
                    )}
                </>
            )}
            <Dialog
                isTermsOpen={isModalOpen}
                setIsTermsOpen={setIsModalOpen}
                title="Comprovante de Pagamento"
            >
                <ContractsModal contract={contractSelected} />
            </Dialog>
        </Container>
    )
}

export default LinkIndividual
